import { render, staticRenderFns } from "./OracleProjectTaskModal.vue?vue&type=template&id=6f549a96"
import script from "./OracleProjectTaskModal.vue?vue&type=script&lang=js"
export * from "./OracleProjectTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports